import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AppProvider, useApp } from "./context/AppContext";
import { Loading } from "./components/common";
import Shell from "./components/Shell";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ModulePage from "./pages/ModulePage";
import SettingsPage from "./pages/SettingsPage";
import PlatformAdmin from "./pages/PlatformAdmin";
import AiAssist from "./pages/AiAssist";
import PrintRecord from "./pages/PrintRecord";
import PortalHome from "./pages/portal/PortalHome";
import PublicDocument from "./pages/portal/PublicDocument";
import GovDashboard, { GovBarangay, GovReports, GovCompleteness, GovSharing, GovAudit } from "./pages/GovPages";
import GovQuery from "./pages/GovQuery";
import GovAdmin from "./pages/GovAdmin";
import { VerifyOtp, PublicSite, ProfileSettings } from "./pages/AuthExtras";

function Home() {
  const { meta } = useApp();
  return meta.gov ? <Navigate to="/gov" replace /> : <Dashboard />;
}

function Protected({ children }) {
  const { status } = useApp();
  if (status === "loading") return <Loading label="Checking session…" />;
  if (status === "anon") return window.location.pathname === "/" ? <PublicSite slug="" /> : <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/b/:slug" element={<PublicSite />} />
          <Route path="/b/:slug/login" element={<Login />} />
          <Route path="/portal" element={<PortalHome />} />
          <Route path="/portal/document/:token" element={<PublicDocument />} />
          <Route path="/print/:key/:id" element={<Protected><PrintRecord /></Protected>} />
          <Route element={<Protected><Shell /></Protected>}>
            <Route index element={<Home />} />
            <Route path="gov" element={<GovDashboard />} />
            <Route path="gov/city/:city" element={<GovDashboard />} />
            <Route path="gov/barangay/:id" element={<GovBarangay />} />
            <Route path="gov/reports" element={<GovReports />} />
            <Route path="gov/completeness" element={<GovCompleteness />} />
            <Route path="gov/sharing" element={<GovSharing />} />
            <Route path="gov/audit" element={<GovAudit />} />
            <Route path="gov/query" element={<GovQuery />} />
            <Route path="gov-admin" element={<GovAdmin />} />
            <Route path="profile" element={<ProfileSettings />} />
            <Route path="m/:key" element={<ModulePage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="platform" element={<PlatformAdmin />} />
            <Route path="ai" element={<AiAssist />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AppProvider>
  );
}
